/**
 * Друк PDF через веб-інтерфейс Нової Пошти (на телефоні зазвичай завантаження / перегляд у новій вкладці).
 */
const NP_MY_BASE = 'https://my.novaposhta.ua';

export const buildNovaPoshtaExpressInvoicePdfUrl = (ttn, apiKey) => {
  const t = String(ttn ?? '').trim();
  const k = String(apiKey ?? '').trim();
  if (!t || !k) return '';
  return `${NP_MY_BASE}/orders/printDocument/orders[]/${encodeURIComponent(t)}/type/pdf/apiKey/${encodeURIComponent(k)}`;
};

export const buildNovaPoshtaMarkingsPdfUrl = (ttn, apiKey) => {
  const t = String(ttn ?? '').trim();
  const k = String(apiKey ?? '').trim();
  if (!t || !k) return '';
  return `${NP_MY_BASE}/orders/printMarkings/orders[]/${encodeURIComponent(t)}/type/pdf/apiKey/${encodeURIComponent(k)}`;
};

/** Відкриття PDF у новій вкладці; якщо заблоковано — спроба через тимчасове посилання. */
export const openPdfUrlInBrowser = (url) => {
  if (!url) return false;
  try {
    const w = window.open(url, '_blank');
    if (w) {
      w.opener = null;
      return true;
    }
  } catch {
    /* ignore */
  }
  try {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return true;
  } catch {
    return false;
  }
};
